import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICertificadoDependenciaDTO } from '../dto/certificado-dependencia.dto';

@Injectable({
  providedIn: 'root'
})
export class CertificadoDependenciaService {

  private urlEndPoint = environment.urlEndPoint.concat('/autenticado/certificado-dependencias');

  constructor(private httpClient: HttpClient) { }

  public findAll(litCodigo: string): Observable<HttpResponse<ICertificadoDependenciaDTO[]>>{
    return this.httpClient.get<ICertificadoDependenciaDTO[]>(`${this.urlEndPoint}/`, { params: { litCodigo }, observe: 'response' });
  }
  
}
